function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var React = require("react");

var styled = require("styled-components").default;

var semver = require("semver");

var text = require("react-addons-text-content");

var _require = require("lodash"),
    omit = _require.omit;

var Code = require("@patternplate/component-code").Code;

var Link = require("@patternplate/component-link").Link;

var Text = require("@patternplate/component-text").Text;

var Flag = require("@patternplate/component-flag").Flag;

module.exports = InfoPane;
module.exports.InnerInfoPane = InnerInfoPane;
var BORDER_RADIUS = 10;
var StyledInfoPane = styled.div.withConfig({
  displayName: "info-pane__StyledInfoPane"
})(["position:relative;width:300px;min-height:300px;height:100%;box-sizing:border-box;border-radius:", ";border-right:1px solid ", ";border-right-width:", "px;overflow:scroll;overflow-x:hidden;background:", ";"], function (props) {
  return props.hermit ? "".concat(BORDER_RADIUS, "px") : "".concat(BORDER_RADIUS, "px 0 0 ").concat(BORDER_RADIUS, "px");
}, function (props) {
  return props.theme.colors.border;
}, function (props) {
  return props.hermit ? 0 : 1;
}, function (props) {
  return props.theme.colors.background;
});
var StyledInnerPane = styled.div.withConfig({
  displayName: "info-pane__StyledInnerPane"
})(["position:relative;z-index:1;background:", ";"], function (props) {
  return props.theme.colors.background;
});
var StyledName = styled.div.withConfig({
  displayName: "info-pane__StyledName"
})(["position:relative;z-index:1;display:flex;flex:0 0 auto;align-items:center;margin-bottom:10px;padding:10px 15px 0 15px;"]);
var StyledToolbar = styled.div.withConfig({
  displayName: "info-pane__StyledToolbar"
})(["display:flex;position:relative;z-index:1;align-items:center;padding:0 15px 10px 15px;"]);
var StyledDisplayName = styled(Text).withConfig({
  displayName: "info-pane__StyledDisplayName"
})(["flex:1 0 auto;color:", ";margin-right:10px;"], function (props) {
  return props.theme.colors.color;
});
var StyledId = styled(Text).withConfig({
  displayName: "info-pane__StyledId"
})(["flex:0 1 auto;color:", ";text-align:right;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"], function (props) {
  return props.theme.colors.recess;
});
var StyledData = styled.table.withConfig({
  displayName: "info-pane__StyledData"
})(["position:relative;z-index:1;flex:0 0 auto;width:100%;border-collapse:collapse;border-spacing:0;"]);
var StyledDataCell = styled.td.withConfig({
  displayName: "info-pane__StyledDataCell"
})(["box-sizing:border-box;height:30px;padding:4px 6px;border-top:1px solid ", ";&:first-child{padding-left:20px;}&:last-child{text-align:right;padding-right:15px;}"], function (props) {
  return props.theme.colors.border;
});
var StyledKey = styled(Text).withConfig({
  displayName: "info-pane__StyledKey"
})(["font-weight:bold;color:", ";"], function (props) {
  return props.theme.colors.color;
});

function SearchTrigger(props) {
  return React.createElement(Link, {
    className: props.className,
    query: {
      "search-enabled": true,
      search: "".concat(props.field, "=").concat(props.search)
    },
    title: "Search other patterns with ".concat(props.field, " \"").concat(props.search, "\"")
  }, props.children);
}

var VERSION_COLOR = function VERSION_COLOR(props) {
  var v = text(props.children);

  if (!semver.valid(v)) {
    return props.theme.colors.error;
  }

  if (semver.satisfies(v, "<=0.1")) {
    return props.theme.colors.error;
  }

  if (semver.satisfies(v, "> 0.1 < 1")) {
    return props.theme.colors.color;
  }

  return props.theme.colors.success;
};

var StyledVersion = styled(Version).withConfig({
  displayName: "info-pane__StyledVersion"
})(["color:", ";&:link,&:visited{text-decoration:none;color:", ";}"], VERSION_COLOR, VERSION_COLOR);
var StyledTag = styled(Tag).withConfig({
  displayName: "info-pane__StyledTag"
})(["display:inline-block;padding:2px 4px;margin-top:1.5px;margin-bottom:1.5px;border:1px solid ", ";border-radius:3px;&:link,&:visited,&:active{text-decoration:none;color:", ";}&:nth-child(2n){margin-left:3px;}"], function (props) {
  return props.theme.colors.color;
}, function (props) {
  return props.theme.colors.color;
});
var StyledToggleHead = styled(ToggleHead).withConfig({
  displayName: "info-pane__StyledToggleHead"
})(["display:flex;align-items:center;height:30px;font-weight:bold;color:", ";padding:3px 15px 3px 20px;box-sizing:border-box;border-top:1px solid ", ";cursor:pointer;"], function (props) {
  return props.theme.colors.color;
}, function (props) {
  return props.theme.colors.border;
});
var StyledToggleBody = styled.div.withConfig({
  displayName: "info-pane__StyledToggleBody"
})(["display:flex;color:", ";box-sizing:border-box;width:100%;padding:5px 15px 5px 20px;box-sizing:border-box;background:", ";"], function (props) {
  return props.theme.colors.color;
}, function (props) {
  return props.theme.colors.background;
});
var StyledCode = styled(Code).withConfig({
  displayName: "info-pane__StyledCode"
})(["width:100%;"]);

function InfoPane(props) {
  var className = props.className;
  var innerProps = omit(props, ["className"]);
  return React.createElement(StyledInfoPane, {
    className: className,
    hermit: props.hermit
  }, React.createElement(InnerInfoPane, _extends({}, innerProps, {
    standalone: true
  })));
}

function InnerInfoPane(props) {
  return React.createElement(StyledInnerPane, {
    standalone: props.standalone,
    className: props.className
  }, React.createElement(StyledName, null, React.createElement(StyledDisplayName, null, props.name), React.createElement(StyledId, null, props.id)), props.children && React.createElement(StyledToolbar, null, props.children), React.createElement(StyledData, null, React.createElement("tbody", null, React.createElement("tr", null, React.createElement(StyledDataCell, null, React.createElement(StyledKey, null, "Version")), React.createElement(StyledDataCell, null, React.createElement(StyledVersion, {
    field: "version",
    search: props.version
  }, props.version))), React.createElement("tr", null, React.createElement(StyledDataCell, null, React.createElement(StyledKey, null, "Flag")), React.createElement(StyledDataCell, null, React.createElement(SearchTrigger, {
    field: "flag",
    search: props.flag
  }, React.createElement(Flag, null, props.flag)))), has(props.tags) && React.createElement("tr", null, React.createElement(StyledDataCell, null, React.createElement(StyledKey, null, "Tags")), React.createElement(StyledDataCell, null, props.tags.map(function (t) {
    return React.createElement(StyledTag, {
      key: t,
      tag: t
    });
  }))), has(props.envs) && props.envs.length > 1 && React.createElement("tr", null, React.createElement(StyledDataCell, null, React.createElement(StyledKey, null, "Environment")), React.createElement(StyledDataCell, null, React.createElement(Select, {
    name: "environment",
    onChange: props.onEnvChange,
    value: props.env.name
  }, props.envs.map(function (e) {
    return React.createElement("option", {
      key: e.name,
      value: e.name
    }, e.displayName);
  })))))), has(props.dependencies) && React.createElement(Toggle, {
    head: "Dependencies (".concat(props.dependencies.length, ")"),
    enabled: props.dependenciesEnabled,
    name: "dependencies"
  }, React.createElement(PatternList, null, props.dependencies.map(function (d) {
    return React.createElement(PatternItem, {
      key: d.id,
      pattern: d
    });
  }))), has(props.dependents) && React.createElement(Toggle, {
    head: "Dependents (".concat(props.dependents.length, ")"),
    enabled: props.dependentsEnabled,
    name: "dependents"
  }, React.createElement(PatternList, null, props.dependents.map(function (d) {
    return React.createElement(PatternItem, {
      key: d.id,
      pattern: d
    });
  }))), has(props.demoDependencies) && React.createElement(Toggle, {
    head: "Demo Dependencies (".concat(props.demoDependencies.length, ")"),
    enabled: props.demoDependenciesEnabled,
    name: "demo-dependencies"
  }, React.createElement(PatternList, null, props.demoDependencies.map(function (d) {
    return React.createElement(PatternItem, {
      key: d.id,
      pattern: d
    });
  }))), has(props.demoDependents) && React.createElement(Toggle, {
    head: "Demo Dependents (".concat(props.demoDependents.length, ")"),
    enabled: props.demoDependentsEnabled,
    name: "demo-dependents"
  }, React.createElement(PatternList, null, props.demoDependents.map(function (d) {
    return React.createElement(PatternItem, {
      key: d.id,
      pattern: d
    });
  }))), React.createElement(Toggle, {
    head: "Manifest",
    enabled: props.manifestEnabled,
    name: "manifest"
  }, React.createElement(StyledCode, {
    block: true,
    language: "json"
  }, props.manifest)));
}

var StyledSelectContainer = styled.div.withConfig({
  displayName: "info-pane__StyledSelectContainer"
})(["position:relative;&::after{position:absolute;right:0;top:50%;z-index:1;content:\"\u25BC\";font-size:0.8em;color:", ";transform:translateY(-50%);}"], function (props) {
  return props.theme.colors.color;
});
var StyledSelect = styled.select.withConfig({
  displayName: "info-pane__StyledSelect"
})(["position:relative;z-index:2;appearance:none;color:", ";background:transparent;font-size:16px;border:none;border-radius:none;padding-right:20px;&:focus{outline:none;}"], function (props) {
  return props.theme.colors.color;
});

function Select(props) {
  return React.createElement(StyledSelectContainer, {
    className: props.className
  }, React.createElement(StyledSelect, {
    onChange: props.onChange,
    value: props.value
  }, props.children));
}

function Version(props) {
  return React.createElement(SearchTrigger, {
    className: props.className,
    search: props.search,
    field: "version"
  }, React.createElement(Text, null, props.search));
}

function Tag(props) {
  return React.createElement(SearchTrigger, {
    className: props.className,
    search: props.tag,
    field: "tags"
  }, React.createElement(Text, null, props.tag));
}

var StyledArrow = styled(Text).withConfig({
  displayName: "info-pane__StyledArrow"
})(["font-size:0.8em;transform:", ";"], function (props) {
  return props.rotated ? "rotate(0deg)" : "rotate(-90deg)";
});
var StyledHead = styled(Link).withConfig({
  displayName: "info-pane__StyledHead"
})(["display:flex;align-items:center;justify-content:space-between;text-decoration:none;"]);

function ToggleHead(props) {
  var query = _defineProperty({}, "".concat(props.name, "-enabled"), !props.enabled);

  return React.createElement(StyledHead, {
    query: query,
    className: props.className,
    title: "".concat(props.enabled ? "Hide" : "Show", " ").concat(props.name)
  }, React.createElement(Text, null, props.children), React.createElement(StyledArrow, {
    rotated: props.enabled
  }, "\u25BC"));
}

var StyledPatternList = styled.div.withConfig({
  displayName: "info-pane__StyledPatternList"
})(["width:100%;"]);

function PatternList(props) {
  return React.createElement(StyledPatternList, null, props.children);
}

var StyledPatternItem = styled(Link).withConfig({
  displayName: "info-pane__StyledPatternItem"
})(["display:block;color:", ";text-decoration:none;padding:3px 0;"], function (props) {
  return props.theme.colors.color;
});

function PatternItem(props) {
  return React.createElement(StyledPatternItem, {
    href: "pattern/".concat(props.pattern.id),
    "data-id": props.pattern.id
  }, React.createElement(Text, null, props.pattern.manifest.displayName));
}

var StyledToggle = styled.div.withConfig({
  displayName: "info-pane__StyledToggle"
})(["position:relative;z-index:1;flex:1 1 auto;min-height:30px;"]);

function Toggle(props) {
  return React.createElement(StyledToggle, null, React.createElement(StyledToggleHead, {
    name: props.name,
    enabled: props.enabled
  }, props.head), props.enabled && React.createElement(StyledToggleBody, null, props.children));
}

function has(val) {
  return Array.isArray(val) && val.length > 0;
}
//# sourceMappingURL=index.js.map